import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as cls from 'classnames';
import { Route, Link, withRouter } from 'react-router-dom';
import { AustraliaMap } from '../../shared';
@withRouter
export class PublishedItem extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = { showDetail: false };
        this.onToggleClicked = this.onToggleClicked.bind(this);
    }

    componentDidMount() {
        let hash = this.props.location.hash;
        if (hash) {
            const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
            if (domElement) {
                domElement.scrollIntoView();
                this.onToggleClicked();
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.location !== prevProps.location) {
            let hash = this.props.location.hash;
            if (hash) {
                const domElement = ReactDOM.findDOMNode(this.refs[hash.replace('#', '')]);
                if (domElement) {
                    domElement.scrollIntoView(false);
                }
            }
        }
    }

    onToggleClicked() {
        this.setState({ showDetail: !this.state.showDetail });
    }

    render() {
        const { location, children, key, idx, title, titleExt, publishedby, year, summary, link, states, focus, authors, anchor, isInternational, ...props } = this.props;

        let authorsRender = authors.map((content, index) => {
            return <span key={"authors" + index}>{content}{authors.length == index + 1 ? "" : ","} </span>
        });

        let focusRender = focus.map((content, index) => {
            return <div key={"focus" + index}>
                <div className=""><span>{content}</span></div>
            </div>
        });
        let toggleCss = this.state.showDetail ? "fa fa-minus fa-lg text-right" : "fa fa-plus fa-lg text-right";
        let titleExtValue = titleExt || "";
        let titleRender = this.state.showDetail ? title + titleExtValue : title;
        let detail = this.state.showDetail ? <div className="row mb-2">
            <div className="col-12 col-md-8 mb-4">
                <strong>FOCUS</strong>
                <div className="mb-4">
                    {focusRender}
                </div>
                <strong >AUTHORS</strong>
                <p>{authorsRender}</p>
                <strong>SUMMARY</strong>
                <p>{summary}</p>
                <div><a className="emphasis-link" target="_blank" href={link}><u>view publication</u></a></div>
            </div>
            <div className="col-12 col-md-4">
                <div className="text-center">
                    {isInternational ? <img width="100%" src={require("../../assets/img/world-map.png")} /> : <AustraliaMap states={states} activeCss="map-active-black" disabledCss="map-disabled" />}
                </div>
            </div>
        </div> : undefined;

        return (
            <div id={anchor} ref={anchor} className="published-item row" >
                <div className="col-12">
                    <div className="row mb-3 mt-3 clickable" onClick={this.onToggleClicked}>
                        <div className="col-12 col-md-6">
                            {titleRender}
                        </div>
                        <div className="col-7 col-md-4">
                            {publishedby}
                        </div>
                        <div className="col-3 col-md-1">
                            {year}
                        </div>

                        <div className="col-2 col-md-1">
                            <span className={toggleCss} onClick={this.onToggleClicked}></span>
                        </div>
                    </div>
                    {detail}
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Publications/PublishedItem.tsx